import { render, staticRenderFns } from "./SOVDetailReport.vue?vue&type=template&id=d6c97384&scoped=true"
import script from "./SOVDetailReport.vue?vue&type=script&lang=js"
export * from "./SOVDetailReport.vue?vue&type=script&lang=js"
import style0 from "./SOVDetailReport.vue?vue&type=style&index=0&id=d6c97384&prod&lang=css"
import style1 from "./SOVDetailReport.vue?vue&type=style&index=1&id=d6c97384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c97384",
  null
  
)

export default component.exports